import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { NAVIGATE_ADMIN, NAVIGATE_DASHBOARDS } from '../constant';
import DashboardListingPage from '../pages/admin/dashboard/components/DashboardListingPage';
import HospitalReferredPage from '../pages/admin/dashboard/HospitalReferList';
import DashboardHospitalReferredPage from '../pages/admin/dashboard/HospitalReferList';
import ReferHospitalTabComponent from '../pages/admin/campaign-activities/referal';
// import DashboardListingMainPage from '../pages/admin/dashboard/dashboard-listing';

// --- Layout & Loaders ---
const AdminLayout = lazy(() => import('../layout/AdminLayout'));
const LoaderText = lazy(() => import('../components/loader/LoaderText'));
const Error404 = lazy(() => import('../pages/error/Error404'));

// --- Dashboard Pages ---
const DashboardPage = lazy(() => import('../pages/admin/dashboard'));
const JatraDashboard = lazy(() => import('../pages/admin/dashboard/JatraDashboard/JatraDashboard'));
const SurveyDashboard = lazy(() => import('../pages/admin/dashboard/survey-dashboard'));
const PolicyDashboard = lazy(() => import('../pages/admin/dashboard/survey-dashboard/SurveyPolicyDashboard'));
const EyeCampDashboard = lazy(() => import('../pages/admin/eye-camp-dashboard'));

// --- Campaign Pages ---
const CampaignListPage = lazy(() => import('../pages/admin/campaign'));
const CampKpiListPage = lazy(() => import('../pages/admin/campaign/CampKpiListPage'));
const CampaignCreatePage = lazy(() => import('../pages/admin/campaign/create'));
const CampaignDetailPage = lazy(() => import('../pages/admin/campaign/detail'));
const CampDocumentsPage = lazy(() => import('../pages/admin/campaign/global-document'));
const PendingActions = lazy(() => import('../pages/admin/campaign/pending-actions'));
const MedicinesList = lazy(() => import('../pages/admin/campaign/medicine'));

// --- Campaign Activities Pages ---
const Schemes = lazy(() => import('../pages/admin/campaign-activities/schemes'));
const SchemeDetailsPage = lazy(() => import('../pages/admin/campaign-activities/schemes/details'));
const AbhaApplications = lazy(() => import('../pages/admin/campaign-activities/abha-card'));
const HLLBloodTestList = lazy(() => import('../pages/admin/campaign-activities/hll'));
const PharmacyConsultations = lazy(() => import('../pages/admin/campaign-activities/hospital/PharmacyConsultations'));
const STEMIListing = lazy(() => import('../pages/admin/campaign-activities/hospital/STEMIConsultations'));
const DoctorScreening = lazy(() => import('../pages/admin/campaign-activities/hospital/DoctorConsultations'));
const OpdConsultations = lazy(() => import('../pages/admin/campaign-activities/hospital/OpdConsultations'));
const ReferralListPage = lazy(() => import('../pages/admin/campaign-activities/referal/ReferralListPage'));

// --- User & Beneficiary Pages ---
const UserListPage = lazy(() => import('../pages/admin/users'));
const BeneficiaryListPage = lazy(() => import('../pages/admin/beneficiary/index'));
const BeneficiaryDetailsPage = lazy(() => import('../pages/admin/beneficiary/detail'));

// --- Master Data Pages ---
const RolesPermissions = lazy(() => import('../pages/admin/masters/role-permissions'));
const MenuMaster = lazy(() => import('../pages/admin/masters/role-permissions/menu'));
const PermissionMaster = lazy(() => import('../pages/admin/masters/role-permissions/permission'));
const SchemeList = lazy(() => import('../pages/admin/masters/scheme'));
const QuestionMasterListing = lazy(() => import('../pages/admin/masters/survey-questions'));

// --- Jatra Pages ---
const JatraListing = lazy(() => import('../pages/admin/jatra'));
const JatraForm = lazy(() => import('../pages/admin/jatra/JatraForm'));

// --- Survey Pages ---
const SurveyList = lazy(() => import('../pages/guest/surveyForm/SurveyList'));

// --- Report Pages ---
const CommunityHealthCampReport = lazy(() => import('../pages/admin/reports'));
const BhajaniMandalListPage = lazy(() => import('../pages/guest/bhajani-mandal/BhajaniMandalList'))

const AdminRoute = () => {
    return (
        <Suspense fallback={<AdminLayout><LoaderText /></AdminLayout>}>
            <Routes>
                {/* --- Dashboard Routes --- */}
                <Route path={NAVIGATE_DASHBOARDS.DASHBOARD} element={<AdminLayout><DashboardPage /></AdminLayout>} />
                <Route path={NAVIGATE_DASHBOARDS.OTHER_DASHBOARD} element={<AdminLayout><DashboardPage /></AdminLayout>} />
                <Route path={NAVIGATE_DASHBOARDS.BENEFICIARY_DASHBOARD} element={<AdminLayout><DashboardPage /></AdminLayout>} />
                <Route path={NAVIGATE_DASHBOARDS.JATRA_DASHBOARD} element={<AdminLayout><JatraDashboard /></AdminLayout>} />
                <Route path={NAVIGATE_DASHBOARDS.SURVEY_DASHBOARD} element={<AdminLayout><SurveyDashboard /></AdminLayout>} />
                <Route path={NAVIGATE_DASHBOARDS.SURVEY_POLICY_DASHBOARD} element={<AdminLayout><PolicyDashboard /></AdminLayout>} />
                <Route path={NAVIGATE_DASHBOARDS.EYE_CAMP_DASHBOARD} element={<AdminLayout><EyeCampDashboard /></AdminLayout>} />
                <Route path={`${NAVIGATE_DASHBOARDS.DASHBOARD_LIST}/*`} element={<AdminLayout><DashboardListingPage /></AdminLayout>} />
                <Route path={`${NAVIGATE_DASHBOARDS.DASHBOARD_HOSPITAL_LIST}/*`} element={<AdminLayout><DashboardHospitalReferredPage /></AdminLayout>} />
                
                {/* --- Campaign & Activities Routes --- */}
                <Route path={NAVIGATE_ADMIN.CAMPAIGN} element={<AdminLayout><CampaignListPage /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.CAMPAIGN_DETAIL} element={<AdminLayout><CampaignDetailPage /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.CAMPAIGN_CREATE} element={<AdminLayout><CampaignCreatePage /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.CAMP_KPI_LIST} element={<AdminLayout><CampKpiListPage /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.PENDING_ACTIONS} element={<AdminLayout><PendingActions /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.SCHEMS} element={<AdminLayout><Schemes /></AdminLayout>} />
                {/* <Route path={'/scheme-details'} element={<AdminLayout><SchemeDetailsPage /></AdminLayout>} /> */}
                <Route path={NAVIGATE_ADMIN.ABHA_CARD} element={<AdminLayout><AbhaApplications /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.CONSULTATIONS} element={<AdminLayout><DoctorScreening /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.OPD_CONSULTATIONS} element={<AdminLayout><OpdConsultations /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.REFERAL_HOSPITAL} element={<AdminLayout><ReferHospitalTabComponent /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.REFERAL_HOSPITAL_LIST} element={<AdminLayout><ReferralListPage forceHospitalList /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.REFERRAL_LIST} element={<AdminLayout><ReferralListPage /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.MEDICIN_LIST} element={<AdminLayout><MedicinesList /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.HLL_BLOOD_TEST} element={<AdminLayout><HLLBloodTestList /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.PHARMACY} element={<AdminLayout><PharmacyConsultations /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.MMHS} element={<AdminLayout><STEMIListing /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.CAMP_DOCUMENTS} element={<AdminLayout><CampDocumentsPage /></AdminLayout>} />

                {/* --- User & Beneficiary Routes --- */}
                <Route path={NAVIGATE_ADMIN.USER_LIST} element={<AdminLayout><UserListPage /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.BENEFICIARY_DETAIL} element={<AdminLayout><BeneficiaryDetailsPage /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.CHECK_IN} element={<AdminLayout><BeneficiaryListPage status="registered" /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.PRE_REG} element={<AdminLayout><BeneficiaryListPage status="pre-registered" /></AdminLayout>} />

                {/* --- Master Data Routes --- */}
                <Route path={NAVIGATE_ADMIN.ROLES_MASTER} element={<AdminLayout><RolesPermissions /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.MENU_MASTER} element={<AdminLayout><MenuMaster /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.PERMISSION_MASTER} element={<AdminLayout><PermissionMaster /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.SCHEME_LIST} element={<AdminLayout><SchemeList /></AdminLayout>} />

                {/* --- Jatra & Survey Routes --- */}
                <Route path={NAVIGATE_ADMIN.CAMP_QUE_ADD} element={<AdminLayout><JatraListing /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.JATRA_CREATE} element={<AdminLayout><JatraForm /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.SUERVEY_QUESTIONS} element={<AdminLayout><QuestionMasterListing /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.SUERVEY_ANSWERS} element={<AdminLayout><SurveyList /></AdminLayout>} />
                <Route path={NAVIGATE_ADMIN.BHAJANI_MANDAL_LIST} element={<AdminLayout><BhajaniMandalListPage /></AdminLayout>} />

                {/* --- Reports --- */}
                <Route path={NAVIGATE_ADMIN.CAMP_REPORT} element={<AdminLayout><CommunityHealthCampReport /></AdminLayout>} />

                {/* --- Fallback Route --- */}
                <Route path='*' element={<AdminLayout><Error404 /></AdminLayout>} />
            </Routes>
        </Suspense>
    )
}

export default AdminRoute;
